/** What a failed assistant request says: the server's own reason (FastAPI
 *  `detail`, a string or `{message}`), else the HTTP status. The assistant used
 *  to read an error body as an answer and print "No response.". */
export async function assistantErrorText(res: Response): Promise<string> {
  let reason = '';
  try {
    const raw = await res.text();
    try {
      const body = JSON.parse(raw);
      const d = body?.detail ?? body?.error ?? body?.message;
      reason = typeof d === 'string' ? d : typeof d?.message === 'string' ? d.message : '';
    } catch {
      reason = raw.trim().slice(0, 200);
    }
  } catch { /* unreadable body */ }
  return reason
    ? `The assistant couldn't answer (HTTP ${res.status}): ${reason}`
    : `The assistant couldn't answer (HTTP ${res.status}). Please try again.`;
}
